import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';
import Home from '../views/Home.vue';
import About from '@/views/About.vue';
import Impressum from '@/views/Impressum.vue';
import Contact from '@/views/Contact.vue';
import Demos from '@/views/Demos.vue';
import Tools from '@/views/Tools.vue';
import Kfz from '@/views/Kfz.vue';
import Kfz2 from '@/components/Kfz2.vue';
import DiaryView from '@/views/DiaryView.vue';
import Rubik from '@/views/Rubik.vue';
import Piano from '@/components/Piano.vue';
import Pentomino from '@/components/Pentomino.vue';
import Towers from '@/components/Towers.vue';
import Smoke from '@/views/Smoke.vue';
import Sokoban from '@/components/Sokoban.vue';
import Stairs from '@/components/Stairs.vue';
import ChessView from '@/views/ChessView.vue';
import TetrisView from '@/views/TetrisView.vue';
import MediaPage from '@/components/MediaPage.vue';
import MediaAdmin from '@/components/MediaAdmin.vue';
import IconList from '@/views/IconList.vue';
import Mrt from '@/components/Mrt.vue';
import RecipesView from '@/views/RecipesView.vue';
import Recipe from '@/components/Recipe.vue';
import RecipePrint from '@/components/RecipePrint.vue';
import Lotto from '@/views/Lotto.vue';
import LottoSim from '@/views/LottoSim.vue';
import LottoPredict from '@/views/LottoPredictView.vue';
import LottoForecast from '@/views/LottoForecastView.vue';
import LottoTestView from '@/views/LottoTestView.vue';
import LottoStats from '@/views/LottoStats.vue';
import Bike from '@/views/Bike.vue';
import BikeStats from '@/views/BikeStats.vue';
import EurojackpotView from '@/views/EurojackpotView.vue';
import EurojackpotSim from '@/views/EurojackpotSim.vue';
// import WorktimeView from '@/views/Worktime/WorktimeView.vue';
// import TasksView from '@/views/Worktime/TasksView.vue';
// import TaskListView from '@/views/Worktime/TaskListView.vue';
// import InvoicesView from '@/views/Worktime/InvoicesView.vue';
// import NewInvoiceView from '@/views/Worktime/NewInvoiceView.vue';
// import MonthView from '@/views/Worktime/MonthView.vue';
import HomematicView from '@/views/Homematic/HomematicView.vue';
import Infinity from '@/views/jewellery/Infinity.vue';
Vue.use(VueRouter);
Vue.use(VueMeta);
const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: { layout: 'desktop' }
    },
    {
        path: '/about',
        name: 'about',
        component: About,
        meta: { layout: 'desktop' }
    },
    {
        path: '/impressum',
        name: 'impressum',
        component: Impressum,
        meta: { layout: 'desktop' }
    },
    {
        path: '/contact',
        name: 'contact',
        component: Contact,
        meta: { layout: 'desktop' }
    },
    {
        path: '/demos',
        name: 'demos',
        component: Demos,
        children: [
            // {
            //   path: '',
            //   // name: 'demos',
            //   component: DemoList
            // },
            {
                path: 'rubik',
                name: 'rubik',
                component: Rubik
            },
            {
                path: 'piano',
                name: 'piano',
                component: Piano
            },
            {
                path: 'pentomino',
                name: 'pentomino',
                component: Pentomino
            },
            {
                path: 'towers',
                name: 'towers',
                component: Towers
            },
            {
                path: 'sokoban',
                name: 'sokoban',
                component: Sokoban
            },
            {
                path: 'chess',
                name: 'chess',
                component: ChessView
            },
            {
                path: 'tetris',
                name: 'tetris',
                component: TetrisView
            },
            {
                path: 'infinity',
                name: 'infinity',
                component: Infinity
            }
        ]
    },
    {
        path: '/tools',
        name: 'tools',
        component: Tools,
        children: [
            {
                path: 'bike',
                name: 'bike',
                component: Bike
            },
            {
                path: 'bikestats',
                name: 'bikestats',
                component: BikeStats
            },
            {
                path: 'lotto',
                name: 'lotto',
                component: Lotto
            },
            {
                path: 'lottoSim',
                name: 'lottoSim',
                component: LottoSim
            },
            {
                path: 'lottoPredict',
                name: 'lottoPredict',
                component: LottoPredict
            },
            {
                path: 'lottoForecast',
                name: 'lottoForecast',
                component: LottoForecast
            },
            {
                path: 'lottoTest',
                name: 'lottoTest',
                component: LottoTestView
            },
            {
                path: 'lottoStats',
                name: 'lottoStats',
                component: LottoStats
            },
            {
                path: 'eurojackpot',
                name: 'eurojackpot',
                component: EurojackpotView
            },
            {
                path: 'eurojackpotSim',
                name: 'eurojackpotSim',
                component: EurojackpotSim
            },
            {
                path: 'kfz2',
                name: 'kfz2',
                component: Kfz2
            },
            {
                path: 'kfz',
                name: 'kfz',
                component: Kfz
            },
            {
                path: 'smoke',
                name: 'smoke',
                component: Smoke
            },
            {
                path: 'media',
                name: 'media',
                component: MediaPage
            },
            {
                path: 'mediaAdmin',
                name: 'mediaAdmin',
                component: MediaAdmin
            },
            {
                path: 'stairs',
                name: 'stairs',
                component: Stairs
            },
            {
                path: 'icons',
                name: 'icons',
                component: IconList
            },
            {
                path: 'mrt',
                name: 'mrt',
                component: Mrt
            },
            {
                path: 'recipes',
                name: 'recipes',
                component: RecipesView
            },
            {
                path: 'recipe/:id',
                name: 'recipe',
                component: Recipe
            },
            {
                path: 'recipePrint/:id',
                name: 'recipePrint',
                component: RecipePrint
            },
            {
                path: 'care',
                name: 'care',
                component: DiaryView
            }
        ]
    },
    // {
    //   path: '/worktime',
    //   name: 'worktime',
    //   component: WorktimeView,
    //   children: [
    //     {
    //       path: 'drives',
    //       name: 'drives',
    //       component: () => import('@/views/Worktime/DrivesView.vue')
    //     },
    //     {
    //       path: 'newInvoice',
    //       name: 'newInvoice',
    //       component: () => import('@/views/Worktime/NewInvoiceView.vue')
    //     },
    //     {
    //       path: 'tasks',
    //       name: 'tasks',
    //       component: TasksView,
    //       children: [
    //         {
    //           path: 'new',
    //           name: 'TaskCreate',
    //           component: () => import('@/views/Worktime/TaskEdit.vue'),
    //           props: true
    //         },
    //         {
    //           path: ':id/edit',
    //           name: 'TaskEdit',
    //           component: () => import('@/views/Worktime/TaskEdit.vue'),
    //           props: true
    //         }
    //       ]
    //     },
    //     {
    //       path: 'tasklist',
    //       name: 'tasklist',
    //       component: TaskListView
    //     },
    //     {
    //       path: 'bills',
    //       name: 'bills',
    //       component: InvoicesView
    //     },
    //     {
    //       path: 'monthView',
    //       name: 'monthView',
    //       component: MonthView
    //     }
    //   ]
    // },
    {
        path: '/homematic',
        name: 'homematic',
        component: HomematicView,
    }
];
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});
router.beforeEach((to, from, next) => {
    console.log('NAV:', from.fullPath, '→', to.fullPath);
    next();
});
export default router;
